export const apiUrl = process.env.REACT_APP_APIURL === 'PRODUCTION'
    ? window.location.origin + process.env.PUBLIC_URL
    : process.env.REACT_APP_APIURL;
